var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","layout":_vm.layoutStr,"current-page":_vm.page,"page-sizes":_vm.pageSizes,"page-size":_vm.pageSize,"total":_vm.pageTotal,"pager-count":_vm.pagerCount,"hide-on-single-page":_vm.isPageSizes ? (_vm.pageTotal ? false : true) : true},on:{"current-change":_vm.changePage,"size-change":_vm.changeSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }